import { render, staticRenderFns } from "./allocationDetail.vue?vue&type=template&id=567a496d&scoped=true"
import script from "./allocationDetail.vue?vue&type=script&lang=js"
export * from "./allocationDetail.vue?vue&type=script&lang=js"
import style0 from "./allocationDetail.vue?vue&type=style&index=0&id=567a496d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a496d",
  null
  
)

export default component.exports